// extracted by mini-css-extract-plugin
export default {"container":"FooterPage_container__3hLcv","testContent":"FooterPage_testContent__AwTiu","spacer":"FooterPage_spacer__MNunV"};